import { BetslipError, ErrorOrigin } from '../betslip-error';
import { ClientErrorType } from '../client-error-type';

export class NotLoggedInError extends BetslipError {
    constructor() {
        super();
        this.type = ClientErrorType.NotLoggedInError;
        this.origin = ErrorOrigin.BetPlacement;
        this.hasClientValidation = true;
    }
}
